import { render, staticRenderFns } from "./ExamStoreCustomer.vue?vue&type=template&id=0c973e0c&scoped=true"
import script from "./ExamStoreCustomer.vue?vue&type=script&lang=js"
export * from "./ExamStoreCustomer.vue?vue&type=script&lang=js"
import style0 from "./ExamStoreCustomer.vue?vue&type=style&index=0&id=0c973e0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c973e0c",
  null
  
)

export default component.exports